// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-import-GS-box {
    position: relative;
    display: block;
    width: 95% !important;
    height: 90%;
    

  }
.row-cont-input-file{
    position: relative;
    display: flex;
    width: 100%;
    height: 15%;
    justify-content: start;
    align-items: center;
    /* background: blue; */
}
.row-cont-input-table{
    position: relative;
    display: block;
    width: 100%;
    height: 70%;
    justify-content: center;
    align-items: center;
    
}
.border-table{
    border:1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    height: 90%;
}
.msgImport{
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}
.txtCantData{
    height: 10%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}
.row-cont-input-buttons{
    position: relative;
    display: flex;
    width: 100%;
    height: 15%;
    /* background: green; */
}


.file-input-container {
    display: flex;
    align-items: center;
  }
  
  .custom-file-button {
    background-color: #007bff;
    color: white;
    border: none;
    height: 4vh;
  width: 20vh;
  font-size: var(--font-size-small);
  font-weight: bold;
    /* padding: 10px 20px; */
    border-radius: 5px;
    cursor: pointer;
    font-size: var(--font-size-small);
    transition: background-color 0.3s ease;
  }
  
  .custom-file-button:hover {
    background-color: #0056b3;
  }
  
  #file-name {
    margin-left: 10px;
    font-size: 14px;
    color: #666;
  }

  .table-import{
    border:1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    height: 100%;
    position: relative;
    width: 80%;
    background-color: red;
  }
  .table-import-head{
    border:1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
    height: 100%;
    position: relative;
    width: 80%;
    background-color: red;
  }

  .no-hover:hover {
  /* Remueve todos los estilos de hover */
  background-color: initial !important;
  color: initial !important;
  cursor: auto !important;
}
 .contTooltpaActDatos {
  position: relative !important;
  display: inline-block !important;
   z-index: 10;
}

  .tooltip-text-actDatos {
  visibility: hidden;
  background-color: rgba(247, 247, 247, 0.918);
  color: var(--third-color);
  border: 1px solid var(--txt-color) ;
  text-align: center;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 15;
  bottom: -60%;
  left: 80%;
  /* transform: translateX(-50%); */
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
}

.contTooltpaActDatos:hover .tooltip-text-actDatos {
  visibility: visible;
  opacity: 1;
}
.contTooltpaActDatos:hover{
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/Hosts/styles/ImportInfo.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,WAAW;;;EAGb;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,WAAW;EACb,WAAW;EACX,iCAAiC;EACjC,iBAAiB;IACf,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,0CAA0C;IAC1C,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,0CAA0C;IAC1C,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,qBAAqB;EACvB;;EAEA;EACA,uCAAuC;EACvC,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;AACzB;CACC;EACC,6BAA6B;EAC7B,gCAAgC;GAC/B,WAAW;AACd;;EAEE;EACA,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iCAAiC;EACjC,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,eAAe;AACjB","sourcesContent":[".cont-import-GS-box {\r\n    position: relative;\r\n    display: block;\r\n    width: 95% !important;\r\n    height: 90%;\r\n    \r\n\r\n  }\r\n.row-cont-input-file{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 15%;\r\n    justify-content: start;\r\n    align-items: center;\r\n    /* background: blue; */\r\n}\r\n.row-cont-input-table{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 70%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    \r\n}\r\n.border-table{\r\n    border:1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    height: 90%;\r\n}\r\n.msgImport{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n.txtCantData{\r\n    height: 10%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n.row-cont-input-buttons{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 15%;\r\n    /* background: green; */\r\n}\r\n\r\n\r\n.file-input-container {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .custom-file-button {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    height: 4vh;\r\n  width: 20vh;\r\n  font-size: var(--font-size-small);\r\n  font-weight: bold;\r\n    /* padding: 10px 20px; */\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: var(--font-size-small);\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .custom-file-button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  #file-name {\r\n    margin-left: 10px;\r\n    font-size: 14px;\r\n    color: #666;\r\n  }\r\n\r\n  .table-import{\r\n    border:1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    height: 100%;\r\n    position: relative;\r\n    width: 80%;\r\n    background-color: red;\r\n  }\r\n  .table-import-head{\r\n    border:1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n    height: 100%;\r\n    position: relative;\r\n    width: 80%;\r\n    background-color: red;\r\n  }\r\n\r\n  .no-hover:hover {\r\n  /* Remueve todos los estilos de hover */\r\n  background-color: initial !important;\r\n  color: initial !important;\r\n  cursor: auto !important;\r\n}\r\n .contTooltpaActDatos {\r\n  position: relative !important;\r\n  display: inline-block !important;\r\n   z-index: 10;\r\n}\r\n\r\n  .tooltip-text-actDatos {\r\n  visibility: hidden;\r\n  background-color: rgba(247, 247, 247, 0.918);\r\n  color: var(--third-color);\r\n  border: 1px solid var(--txt-color) ;\r\n  text-align: center;\r\n  border-radius: 4px;\r\n  padding: 5px;\r\n  position: absolute;\r\n  z-index: 15;\r\n  bottom: -60%;\r\n  left: 80%;\r\n  /* transform: translateX(-50%); */\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n.contTooltpaActDatos:hover .tooltip-text-actDatos {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.contTooltpaActDatos:hover{\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
